import school1 from "../../assets/school_image.png";

const History = () => {
    return (
        <div id="history" className="vision-card">
            <div className="about-intro-grid">
                <div className="about-text">
                    <h2>SCHOOL HISTORY</h2>
                    <p>
                    </p>
                    <p>
                       Nav Jeevan Mission International School, Gorakhpur, is committed to providing quality 
                       education in a nurturing and disciplined environment. The school focuses on academic 
                       excellence, character development, and holistic growth, empowering students with the 
                       knowledge, values, and skills needed to succeed in an ever-changing world.
                    </p>

                </div>

                <div className="about-img">
                    <img src={school1} alt="Nav Jeevan Mission School" />
                </div>
            </div>
        </div>


    );
};

export default History;